export default {
    path: '/task',
    name: 'Task',
    component: () => import(/* webpackChunkName: "task" */ '../../views/task/task.vue')
}